import React from 'react'
import { foldText } from './ColumnFilter/ColumnFilterTypes'

/**
 * Durum metnini açık tonlu, renkli bir rozet olarak gösterir (Metronic `badge-light-*`).
 * Renk metindeki anahtar kelimeden seçilir; yeni bir durum eklendiğinde çoğu zaman
 * kendiliğinden doğru renge düşer, düşmezse gri görünür.
 *
 * Kullanımı: <StatusBadge text={item.shippingStatusName} />
 */
export type StatusTone = 'success' | 'primary' | 'info' | 'warning' | 'danger' | 'light'

// Sıra önemli: ilk eşleşen kural kazanır ("teslim edilemedi" "teslim edildi"den,
// "kısmi faturalandı" "faturalandı"dan önce yakalanmalı).
const RULES: [string[], StatusTone][] = [
    // Beyanname durumu (Antrepo Girişi): açık süreçte mavi, kapanmış gri (uyarı değil).
    [['kapali beyanname'], 'light'],
    [['acik beyanname'], 'primary'],
    // Olumsuz: teslim edilemedi, iade, iptal, kayıp, reddedildi, hurda…
    [['edilemedi', 'iade', 'iptal', 'hatali', 'hata', 'silindi', 'hasar', 'kayip', 'basarisiz', 'faturalanmadi', 'reddedildi', 'hurda', 'islenmedi'], 'danger'],
    // Dikkat: kısmi, değişti, bekliyor, revize, kapalı, tadilatlı, sahaya alınsın, ödeme…
    [['kismi', 'kismen', 'degisti', 'bekliyor', 'beklemede', 'ertelendi', 'revize', 'kapali', 'tadilatli', 'alinsin', 'tedarik', 'odeme', 'eksik bilgi', 'gonderilmedi'], 'warning'],
    // Olumlu / tamamlanmış: teslim edildi, faturalandı, onaylandı, çalışılan müşteri, aktif, stokta…
    [['teslim edildi', 'gonderildi', 'basarili', 'faturalandi', 'onaylandi', 'tamamlandi', 'calisilan', 'aktif', 'sifir', 'stokta', 'antrepoda', 'serbest depo', 'tahsilat', 'fatura', 'bitti', 'acik'], 'success'],
    // Evet/Hayır kolonları (Aktif vb.): Evet yeşil, Hayır gri.
    [['evet'], 'success'],
    // Sistem tarafından otomatik yapılan (ör. Elle Güncellendi = Otomatik): mavi.
    [['otomatik'], 'primary'],
    // Süreçte: yüklendi, yolda, geldi, takipte, kullanımda, özmal, hedef müşteri…
    [['yuklendi', 'kuyrukta', 'isleniyor', 'dagitim', 'yolda', 'cikis', 'geldi', 'takipte', 'kullanimda', 'ozmal', 'hedef', 'basladi', 'calisiyor'], 'primary'],
    // Ara adım / bilgi: indirildi, transfer, sahaya alındı, kantara girdi, planlandı, kiralık, potansiyel…
    [['indirildi', 'hub', 'transfer', 'aktarma', 'subede', 'depoda', 'alindi', 'girdi', 'yanasti', 'planlandi', 'kullanilmis', 'kiralik', 'potansiyel', 'olusturuldu'], 'info'],
]

export const statusTone = (text: string | undefined | null): StatusTone => {
    const t = foldText(text ?? '')

    for (const [words, tone] of RULES)
        if (words.some(w => t.includes(w)))
            return tone

    return 'light'
}

interface Props {
    text: string | undefined | null
}

const StatusBadge = ({ text }: Props) => {
    if (!text)
        return null

    const tone = statusTone(text)

    // Gri rozetin sınıfı "badge-light"; diğerleri "badge-light-<renk>".
    return <span className={'badge ' + (tone == 'light' ? 'badge-light' : 'badge-light-' + tone) + ' ebbe-status-badge'}>{text}</span>
}

export default StatusBadge
